import { render, staticRenderFns } from "./yxmarketing_add.vue?vue&type=template&id=4f1bdc40&scoped=true&"
import script from "./yxmarketing_add.vue?vue&type=script&lang=js&"
export * from "./yxmarketing_add.vue?vue&type=script&lang=js&"
import style0 from "./yxmarketing_add.vue?vue&type=style&index=0&id=4f1bdc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1bdc40",
  null
  
)

export default component.exports